export const msalConfig = {
    // added mhfd client and tenant id.
    // ************** PROD AUTH *****************
    auth: {
        clientId: "a35c85e3-fb5c-4ec0-89c3-9f57a18ca1f9", // new registration test 2/10/2025 to allow all orgs
        authority: "https://login.microsoftonline.com/organizations",  //"https://login.microsoftonline.com/05d35a36-0869-40b0-98f7-4066dbbdfb64", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
        //redirectUri:  "https://polite-water-087334c10.4.azurestaticapps.net", // Mahesh added as temporary fix till ctdb.azurewebsites.net can be resolved.
        redirectUri:  "https://contact.lcsmc.org/",
        // redirectUri: "http://localhost:3000",
    },
    // ************** DEV AUTH ****************
    // auth: {
    //     clientId: "84ce7323-7c74-4e28-8b4d-47e2de52162a",
    //     authority: "https://login.microsoftonline.com/9e4efa97-3ade-4c5e-8b54-1c8c0a760576", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    //     redirectUri: "http://localhost:3000",
    //     // redirectUri: "https://witty-pond-057e3ca1e.5.azurestaticapps.net",
    // },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    //************PROD AUTH */
    scopes: ["api://a35c85e3-fb5c-4ec0-89c3-9f57a18ca1f9/read"]

    //************DEV AUTH********* */
    // scopes: ["api://84ce7323-7c74-4e28-8b4d-47e2de52162a/read.scope"]
};

export const graphRequest = {
    scopes: ['openid', 'profile', 'email', 'User.Read', 'User.Read.All', 'User.ReadBasic.All', 'IdentityProvider.Read.All'] // mahesh added this to test new clientID ending with 7a18ca1f9
    //scopes: ['openid', 'profile', 'email', 'User.Read', "IdentityProvider.Read.All"]
}

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};